// // src/context/AuthContext.jsx
// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { getAuthToken, logout } from '../utils/auth';

// const AuthContext = createContext(null);

// export function AuthProvider({ children }) {
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     const token = getAuthToken();
//     if (!token) return;

//     try {
//       // quick, non-verified decode of JWT payload
//       const payload = JSON.parse(atob(token.split('.')[1]));
//       // basic expiration check
//       if (payload.exp && Date.now() >= payload.exp * 1000) {
//         logout();
//         setUser(null);
//       } else {
//         setUser({
//           email: payload.email,
//           name: payload.name || null,
//           sub: payload.sub || null,
//         });
//       }
//     } catch (err) {
//       // If decode fails, you could call /api/me to retrieve user from server
//       console.warn('Could not decode token on startup', err);
//     }
//   }, []);

//   return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
// }

// export const useAuth = () => {
//   const ctx = useContext(AuthContext);
//   if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
//   return ctx;
// };


import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuthToken, logout } from '../utils/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = getAuthToken();
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));

      if (payload.exp && Date.now() >= payload.exp * 1000) {
        logout();
        setUser(null);
      } else {
        // Make sure the context user matches custom login fields
        setUser({
          id: payload.id || payload.sub, // support both custom & google
          first_name: payload.first_name || null,
          last_name: payload.last_name || null,
          email: payload.email,
          role: payload.role || 'user',
        });
      }
    } catch (err) {
      console.warn('Could not decode token on startup', err);
    }
  }, []);

  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
